export default __webpack_public_path__ + "static/media/getQuote.271a0fc9.jpg";